<template>
  <ProgressLoader :show="showLoader" />
</template>

<script setup lang="ts">
import axios from "axios";
import { ref } from "vue";
import ProgressLoader from "./ProgressLoader.vue";

const showLoader = ref(false);
const endpoint = import.meta.env.VITE_BIRDHOUSE_ENDPOINT as string;

let timerId = 0;
let requestCount = 0;

function shouldIgnore(url?: string): boolean {
  if (url && url.startsWith(endpoint)) return false;
  return true;
}

function requestStarted(url?: string): void {
  if (shouldIgnore(url)) return;
  requestCount++;
  if (timerId) return;
  timerId = window.setTimeout(() => {
    showLoader.value = true;
    timerId = 0;
  }, 500);
}

function requestEnded(url?: string): void {
  if (shouldIgnore(url)) return;
  requestCount--;
  if (requestCount > 0) return;
  if (timerId) window.clearTimeout(timerId);
  timerId = 0;
  showLoader.value = false;
}

// Axios interceptors
axios.interceptors.request.use(
  (config) => {
    requestStarted(config?.url);
    return config;
  },
  (error) => {
    requestEnded(error?.config?.url);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    requestEnded(response?.config?.url);
    return response;
  },
  (error) => {
    requestEnded(error?.config?.url);
    return Promise.reject(error);
  }
);
</script>
